module.exports = __webpack_public_path__ + "img/product-ketang-zzct-07.79fede6b.png";